import { catalog } from '../core/catalog.js';
import { t } from '../core/i18n.js';
import { debounce } from '../core/utils.js';
import { movieCard, seriesCard, channelCard, continueCard, row, empty, enhance, pageHead } from '../ui/render.js';

export default {
    path: '/mylist/',
    nav: 'mylist',

    render() {
        return `<div class="page" data-name="mylist">
            <div class="page-content">
                ${pageHead({ title: t('nav.mylist') })}
                <div data-rows></div>
            </div>
        </div>`;
    },

    mount(page) {
        const root = page.el;
        const box = root.querySelector('[data-rows]');
        const paint = () => {
            const cont = catalog.continueWatching(30);
            const live = catalog.favoriteItems('live');
            const vod = catalog.favoriteItems('vod');
            const series = catalog.favoriteItems('series');
            const html = [
                row({ id: 'continue', title: t('home.continue'), items: cont.map(continueCard), kind: 'wide' }),
                row({ id: 'live', title: t('nav.live'), items: live.map(channelCard), kind: 'channel' }),
                vod.length ? `<section class="section"><div class="section-head"><h2 class="section-title">${t('nav.movies')}</h2></div><div class="grid">${vod.map(movieCard).join('')}</div></section>` : '',
                series.length ? `<section class="section"><div class="section-head"><h2 class="section-title">${t('nav.series')}</h2></div><div class="grid">${series.map(seriesCard).join('')}</div></section>` : ''
            ].join('');
            const rec = window.IPTV.account.canRecord ? `<section class="section"><div class="section-head"><h2 class="section-title">${t('rec.title')}</h2><a class="section-link" href="#" data-href="/recordings/">${t('common.seeAll')} <span class="mi">chevron_right</span></a></div></section>` : '';
            box.innerHTML = (html + rec) || empty({ icon: 'bookmark_border', title: t('home.emptyTitle'), text: t('home.emptyText') });
            enhance(box);
        };
        paint();
        const off = catalog.on('change', debounce(paint, 200));
        return () => off();
    }
};
